// extracted by mini-css-extract-plugin
module.exports = {"loading":"_1v-WQTdHZOfG5RA1dTiYiM","notLoading":"_24smXQ7oYIxCltdYo-TZI2"};